var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefrigeration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.99,39.53L29.76,40l1.51-0.87l-1.34-0.36C29.3,39.05,28.65,39.31,27.99,39.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.97,33.14c-0.38,0.5-0.78,0.97-1.2,1.43l1.2,0.69V33.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.28,38.09l1.22,0.33l3.97-2.29l-1.42-0.82C33.92,36.38,32.66,37.33,31.28,38.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.97,31.68c0.43-0.7,0.82-1.42,1.16-2.18l-1.16,1.16V31.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.34,39.6c0.07-0.27,0.35-0.42,0.61-0.35l1.04,0.28c0.67-0.21,1.31-0.47,1.94-0.76l-1.92-0.51 c-0.27-0.07-0.42-0.35-0.35-0.61c0.07-0.27,0.35-0.42,0.61-0.35l3.01,0.81c1.38-0.77,2.64-1.71,3.77-2.79l-2.55-1.47l-4.23,1.13 c-0.04,0.01-0.09,0.02-0.13,0.02c-0.22,0-0.42-0.15-0.48-0.37c-0.07-0.27,0.09-0.54,0.35-0.61l3.26-0.87l-1.51-0.87L26.95,33 c-0.04,0.01-0.09,0.02-0.13,0.02c-0.22,0-0.42-0.15-0.48-0.37c-0.07-0.27,0.09-0.54,0.35-0.61l1.84-0.49l-2.07-1.2 c-0.24-0.14-0.32-0.44-0.18-0.68c0.14-0.24,0.44-0.32,0.68-0.18l2.07,1.2l-0.49-1.84c-0.07-0.27,0.09-0.54,0.35-0.61 c0.27-0.07,0.54,0.09,0.61,0.35l0.75,2.81l1.51,0.87L30.9,29c-0.07-0.27,0.09-0.54,0.35-0.61c0.27-0.06,0.54,0.09,0.61,0.35 L33,32.96l2.77,1.6c0.42-0.45,0.82-0.93,1.2-1.43v-2.47l-3.09-3.09c-0.2-0.2-0.2-0.51,0-0.71s0.51-0.2,0.71,0l2.39,2.39v-1.75 l-2.05-2.05c-0.2-0.2-0.2-0.51,0-0.71s0.51-0.2,0.71,0l1.35,1.35V23.7c0-0.28,0.22-0.5,0.5-0.5s0.5,0.22,0.5,0.5v2.39l1.35-1.35 c0.2-0.2,0.51-0.2,0.71,0s0.2,0.51,0,0.71l-2.05,2.05v1.75l1.99-1.99c0.45-1.52,0.7-3.12,0.74-4.78c-0.15-0.09-0.25-0.24-0.25-0.43 c0-9.98-8.11-18.1-18.08-18.1c-9.98,0-18.1,8.12-18.1,18.1c0,9.97,8.12,18.08,18.1,18.08c0.19,0,0.34,0.11,0.43,0.26 c1.23-0.03,2.42-0.17,3.58-0.43C26.33,39.85,26.31,39.73,26.34,39.6z M8.09,22.05c0,0.28-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5 c0-8.42,6.85-15.28,15.28-15.28c8.41,0,15.26,6.85,15.26,15.28c0,0.28-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5 c0-7.87-6.4-14.28-14.26-14.28C14.5,7.78,8.09,14.18,8.09,22.05z M22.36,29.09c-1.94,0-3.51-1.59-3.51-3.53S22.36,15,22.36,15 s3.51,8.62,3.51,10.56S24.3,29.09,22.36,29.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.99,22.04c0-10.14,8.22-18.37,18.37-18.37c10.14,0,18.37,8.23,18.37,18.37c0,0.15-0.02,0.29-0.02,0.44 c0.07,0.04,0.15,0.07,0.25,0.07c0.28,0,0.5-0.22,0.5-0.5c0-10.53-8.56-19.1-19.08-19.1c-10.53,0-19.1,8.57-19.1,19.1 c0,10.52,8.57,19.08,19.1,19.08c0.28,0,0.5-0.22,0.5-0.5c0-0.09-0.03-0.17-0.07-0.24c-0.15,0-0.29,0.02-0.44,0.02 C12.21,40.41,3.99,32.18,3.99,22.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.37,40.14c-9.98,0-18.1-8.11-18.1-18.08c0-9.98,8.12-18.1,18.1-18.1c9.97,0,18.08,8.12,18.08,18.1 c0,0.19,0.1,0.34,0.25,0.43c0-0.15,0.02-0.29,0.02-0.44c0-10.14-8.23-18.37-18.37-18.37c-10.15,0-18.37,8.23-18.37,18.37 c0,10.14,8.22,18.37,18.37,18.37c0.15,0,0.29-0.02,0.44-0.02C22.71,40.24,22.56,40.14,22.37,40.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.63,22.05c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5c0-8.42-6.84-15.28-15.26-15.28 c-8.42,0-15.28,6.85-15.28,15.28c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5c0-7.87,6.41-14.28,14.28-14.28 C30.23,7.78,36.63,14.18,36.63,22.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.85,25.56c0,1.94,1.57,3.53,3.51,3.53c1.94,0,3.51-1.59,3.51-3.53S22.36,15,22.36,15 S18.85,23.62,18.85,25.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.97,36.99v3.6l0.15-0.15c0.2-0.2,0.51-0.2,0.71,0l0.15,0.15v-3.6l-0.5-0.29L36.97,36.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.97,35.26l0.5,0.29l0.5-0.29v-3.57c-0.31,0.5-0.64,0.99-1,1.45V35.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.97,42v1.75l0.15-0.15c0.09-0.09,0.22-0.15,0.35-0.15s0.26,0.05,0.35,0.15l0.15,0.15v-1.75l-0.5-0.5 L36.97,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.97,45.17v3.38c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5v-3.38l-0.5-0.5L36.97,45.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.83,30.82c-0.09,0.09-0.22,0.15-0.35,0.15s-0.26-0.05-0.35-0.15l-0.15-0.15v2.47 c0.36-0.47,0.69-0.95,1-1.45v-1.01L37.83,30.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.97,29.26v-1.75l-0.15,0.15c-0.09,0.09-0.22,0.15-0.35,0.15s-0.26-0.05-0.35-0.15l-0.15-0.15v1.75l0.5,0.5 L37.97,29.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.97,26.09V23.7c0-0.28-0.22-0.5-0.5-0.5s-0.5,0.22-0.5,0.5v2.39l0.5,0.5L37.97,26.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.07,27.58c0.2-0.2,0.2-0.51,0-0.71s-0.51-0.2-0.71,0l-0.39,0.39c-0.23,0.77-0.51,1.52-0.83,2.25 L41.07,27.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.97,30.67l1.16-1.16c0.32-0.73,0.6-1.48,0.83-2.25l-1.99,1.99V30.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.58,26.87c-0.2-0.2-0.51-0.2-0.71,0s-0.2,0.51,0,0.71l3.09,3.09v-1.41L34.58,26.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.47,30.96c0.13,0,0.26-0.05,0.35-0.15l0.15-0.15v-1.41l-0.5,0.5l-0.5-0.5v1.41l0.15,0.15 C37.21,30.91,37.34,30.96,37.47,30.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.03,25.45c0.2-0.2,0.2-0.51,0-0.71s-0.51-0.2-0.71,0l-1.35,1.35v1.41L40.03,25.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.62,24.74c-0.2-0.2-0.51-0.2-0.71,0s-0.2,0.51,0,0.71l2.05,2.05v-1.41L35.62,24.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.47,27.8c0.13,0,0.26-0.05,0.35-0.15l0.15-0.15v-1.41l-0.5,0.5l-0.5-0.5v1.41l0.15,0.15 C37.21,27.75,37.34,27.8,37.47,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.36,44.39c0.1,0.1,0.23,0.15,0.35,0.15s0.26-0.05,0.35-0.15c0.2-0.2,0.2-0.51,0-0.71l-3.09-3.09v1.41 L40.36,44.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.88,43.69c-0.2,0.2-0.2,0.51,0,0.71s0.51,0.2,0.71,0L36.97,42v-1.41L33.88,43.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.12,40.44l-0.15,0.15V42l0.5-0.5l0.5,0.5v-1.41l-0.15-0.15C37.63,40.25,37.31,40.25,37.12,40.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.32,46.52c0.1,0.1,0.23,0.15,0.35,0.15s0.26-0.05,0.35-0.15c0.2-0.2,0.2-0.51,0-0.71l-2.05-2.05v1.41 L39.32,46.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.92,45.81c-0.2,0.2-0.2,0.51,0,0.71s0.51,0.2,0.71,0l1.35-1.35v-1.41L34.92,45.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.47,43.46c-0.13,0-0.26,0.05-0.35,0.15l-0.15,0.15v1.41l0.5-0.5l0.5,0.5v-1.41l-0.15-0.15 C37.73,43.51,37.6,43.46,37.47,43.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.31,39.5l1.51,0.87l-0.05-0.2c-0.07-0.27,0.09-0.54,0.35-0.61l0.2-0.05l-1.51-0.87l-0.68,0.18L42.31,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.97,35.26l-1.2-0.69c-0.24,0.25-0.47,0.5-0.72,0.74l1.42,0.82l0.5-0.29V35.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.05,41.08l2.93,1.69c0.08,0.05,0.17,0.07,0.25,0.07c0.17,0,0.34-0.09,0.43-0.25 c0.14-0.24,0.06-0.54-0.18-0.68l-2.93-1.69l-0.68,0.18L45.05,41.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.97,36.99l3.12,1.8l-0.05-0.2c-0.07-0.27,0.09-0.54,0.35-0.61l0.2-0.05l-3.12-1.8l-0.5,0.29V36.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.03,30.67l-2.07-1.2c-0.24-0.14-0.54-0.06-0.68,0.18c-0.14,0.24-0.06,0.54,0.18,0.68l2.07,1.2l0.68-0.18 L29.03,30.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.77,34.56L33,32.96l0.05,0.2c0.03,0.13,0.02,0.26-0.05,0.38c-0.07,0.12-0.17,0.2-0.3,0.23l-0.2,0.05 l2.55,1.47C35.3,35.06,35.54,34.82,35.77,34.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.77,32.26l-1.51-0.87l0.05,0.2c0.03,0.13,0.02,0.26-0.05,0.38c-0.07,0.12-0.17,0.2-0.3,0.23l-0.2,0.05 l1.51,0.87l0.68-0.18L31.77,32.26z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "37.47,35.55 36.97,35.26 36.97,35.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "37.47,36.7 37.97,36.99 37.97,36.41  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.87,28.74c-0.07-0.27-0.34-0.42-0.61-0.35c-0.27,0.07-0.42,0.35-0.35,0.61l0.88,3.26L33,32.96L31.87,28.74z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.01,34c-0.27,0.07-0.42,0.35-0.35,0.61c0.06,0.22,0.26,0.37,0.48,0.37c0.04,0,0.09-0.01,0.13-0.02 l4.23-1.13l-1.23-0.71L28.01,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,33.54c0.07-0.12,0.08-0.25,0.05-0.38L33,32.96l-1.23-0.71l0.18,0.68l-0.68,0.18l1.23,0.71l0.2-0.05 C32.83,33.74,32.94,33.66,33,33.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.51,28.58c-0.07-0.27-0.34-0.42-0.61-0.35c-0.27,0.07-0.42,0.35-0.35,0.61l0.49,1.84l1.23,0.71L29.51,28.58 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.69,32.03c-0.27,0.07-0.42,0.35-0.35,0.61c0.06,0.22,0.26,0.37,0.48,0.37c0.04,0,0.09-0.01,0.13-0.02 l2.81-0.75l-1.23-0.71L26.69,32.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.26,31.96c0.07-0.12,0.08-0.25,0.05-0.38l-0.05-0.2l-1.23-0.71l0.18,0.68l-0.68,0.18l1.23,0.71l0.2-0.05 C30.09,32.16,30.2,32.08,30.26,31.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.08,37.76c0.27-0.07,0.42-0.35,0.35-0.61c-0.07-0.27-0.34-0.42-0.61-0.35l-4.23,1.13l1.23,0.71L46.08,37.76 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.22,43.02c0.06,0.22,0.26,0.37,0.48,0.37c0.04,0,0.09-0.01,0.13-0.02c0.27-0.07,0.42-0.35,0.35-0.61 l-0.87-3.26l-1.23-0.71L42.22,43.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.04,38.59l0.05,0.2l1.23,0.71l-0.18-0.68l0.68-0.18l-1.23-0.71l-0.2,0.05 C41.12,38.05,40.96,38.32,41.04,38.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.4,39.72c0.27-0.07,0.42-0.35,0.35-0.61c-0.07-0.27-0.34-0.42-0.61-0.35l-2.81,0.75l1.23,0.71L47.4,39.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.58,43.18c0.06,0.22,0.26,0.37,0.48,0.37c0.04,0,0.09-0.01,0.13-0.02c0.27-0.07,0.42-0.35,0.35-0.61 l-0.49-1.84l-1.23-0.71L44.58,43.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.78,40.17l0.05,0.2l1.23,0.71l-0.18-0.68l0.68-0.18l-1.23-0.71l-0.2,0.05 C43.86,39.63,43.71,39.91,43.78,40.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.27,39.13L29.76,40l0.2,0.05c0.27,0.07,0.42,0.35,0.35,0.61l-0.05,0.2l1.51-0.87l0.18-0.68L31.27,39.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.53,40.71l-2.07,1.2c-0.24,0.14-0.32,0.44-0.18,0.68c0.09,0.16,0.26,0.25,0.43,0.25 c0.08,0,0.17-0.02,0.25-0.07l2.07-1.2l0.18-0.68L28.53,40.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.47,36.12l-3.97,2.29l0.2,0.05c0.13,0.04,0.24,0.12,0.3,0.23c0.07,0.12,0.08,0.25,0.05,0.38L33,39.28 l3.97-2.29v-0.58L36.47,36.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.09,34.04c-0.07-0.12-0.08-0.25-0.05-0.38l0.05-0.2l-3.12,1.8v0.58l0.5,0.29l3.12-1.8l-0.2-0.05 C41.26,34.24,41.15,34.15,41.09,34.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.83,32.46c-0.07-0.12-0.08-0.25-0.05-0.38l0.05-0.2l-1.51,0.87l-0.18,0.68l0.68,0.18l1.51-0.87l-0.2-0.05 C44,32.65,43.89,32.57,43.83,32.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.67,29.66c-0.14-0.24-0.44-0.32-0.68-0.18l-2.93,1.69l-0.18,0.68l0.68,0.18l2.93-1.69 C48.72,30.21,48.8,29.9,48.67,29.66z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "36.97,36.41 36.97,36.99 37.47,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "37.97,35.84 37.97,35.26 37.47,35.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "36.47,36.12 36.97,36.41 36.97,35.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "37.97,36.41 38.47,36.12 37.97,35.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "36.97,35.84 36.97,36.41 37.47,36.7 37.97,36.41 37.97,35.84 37.47,35.55  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.9,43.25c-0.07,0.27,0.09,0.54,0.35,0.61c0.04,0.01,0.09,0.02,0.13,0.02c0.22,0,0.42-0.15,0.48-0.37 L33,39.28l-1.23,0.71L30.9,43.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.93,38.77l1.34,0.36l1.23-0.71l-1.22-0.33C30.84,38.34,30.39,38.56,29.93,38.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.27,37.29c-0.27-0.07-0.54,0.09-0.61,0.35c-0.07,0.27,0.09,0.54,0.35,0.61l1.92,0.51 c0.46-0.21,0.91-0.43,1.35-0.67L28.27,37.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,38.71c-0.07-0.12-0.17-0.2-0.3-0.23l-0.2-0.05l-1.23,0.71l0.68,0.18l-0.18,0.68L33,39.28l0.05-0.2 C33.09,38.96,33.07,38.82,33,38.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.54,43.41c-0.07,0.27,0.09,0.54,0.35,0.61c0.04,0.01,0.09,0.02,0.13,0.02c0.22,0,0.42-0.15,0.48-0.37 l0.75-2.81l-1.23,0.71L28.54,43.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.99,39.53c-0.53,0.17-1.06,0.31-1.61,0.43c0.06,0.12,0.17,0.22,0.31,0.26l1.84,0.49L29.76,40L27.99,39.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.95,39.25c-0.27-0.07-0.54,0.09-0.61,0.35c-0.03,0.12-0.01,0.25,0.04,0.36c0.54-0.12,1.08-0.26,1.61-0.43 L26.95,39.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.96,40.05L29.76,40l-1.23,0.71l0.68,0.18l-0.18,0.68l1.23-0.71l0.05-0.2 C30.38,40.4,30.22,40.13,29.96,40.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.82,35.46c0.04,0.01,0.09,0.02,0.13,0.02c0.22,0,0.42-0.15,0.48-0.37c0.07-0.27-0.09-0.54-0.35-0.61 l-3.26-0.87l-1.23,0.71L45.82,35.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.19,29.49c0.07-0.27-0.09-0.54-0.35-0.61c-0.27-0.06-0.54,0.09-0.61,0.35l-1.13,4.23l1.23-0.71L43.19,29.49 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.32,32.75l-1.23,0.71l-0.05,0.2c-0.03,0.13-0.02,0.26,0.05,0.38s0.17,0.2,0.3,0.23l0.2,0.05l1.23-0.71 l-0.68-0.18L42.32,32.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.14,33.49c0.04,0.01,0.09,0.02,0.13,0.02c0.22,0,0.42-0.15,0.48-0.37c0.07-0.27-0.09-0.54-0.35-0.61 l-1.84-0.49l-1.23,0.71L47.14,33.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.55,29.33c0.07-0.27-0.09-0.54-0.35-0.61c-0.27-0.07-0.54,0.09-0.61,0.35l-0.75,2.81l1.23-0.71L45.55,29.33 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.06,31.17l-1.23,0.71l-0.05,0.2c-0.03,0.13-0.02,0.26,0.05,0.38s0.17,0.2,0.3,0.23l0.2,0.05l1.23-0.71 l-0.68-0.18L45.06,31.17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigeration);
export default __webpack_public_path__ + "static/media/refrigeration.eea6a4a6c1481a1d940d48223a352ce7.svg";
export { ForwardRef as ReactComponent };